import React, {Children} from 'react';

import {ErrorBoundary} from '@sentry/react';
import clsx from 'clsx';

import {Group} from '@pb/kit-component-group';

import {ProfileTabSeparator} from './profile-tab-separator';

import {
    profileTabStructure,
    profileTabStructureMain,
    profileTabStructureSidebar,
} from './profile-tab-structure.module.styl';

import type {ReactNode} from 'react';

type Props = {
    width: number,
    sidebar?: ReactNode,
    main?: ReactNode,
    minWidth?: number,
};

export const ProfileTabStructure: React.FC<Props> = props => {
    const {width, sidebar, main, minWidth} = props;

    const classes = clsx([profileTabStructure, 'enable-selection']);

    return (
        <div className={classes}>
            {sidebar ? (
                <div className={profileTabStructureSidebar} style={{width, minWidth}}>
                    {Children.map(sidebar, (e, index) => (
                        <Group direction="v" key={index} gap="l">
                            <ErrorBoundary>
                                {e}
                            </ErrorBoundary>
                            {index !== Children.count(sidebar) - 1 && <ProfileTabSeparator/>}
                        </Group>
                    ))}
                </div>
            ) : null}
            <div className={profileTabStructureMain}>{main}</div>
        </div>
    );
};
